// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multi-selector{margin:20px 0}", "",{"version":3,"sources":["webpack://./client/components/multi-selector/multi-selector.scss"],"names":[],"mappings":"AACA,gBACE,aAAA","sourcesContent":["@import \"~@/styles/index.scss\";\n.multi-selector {\n  margin: 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
